module.exports = __webpack_public_path__ + "img/youjian.694d773e.png";